import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { AuthProvider } from './hooks/useAuth.js'
import { NotificationProvider } from './hooks/useNotifications.jsx'
import { BrandingProvider } from './hooks/useBranding.jsx'
import { PrivacyProvider } from './hooks/usePrivacy.jsx'
import EnvironmentBanner from './components/common/EnvironmentBanner.jsx'
import MovedBanner from './components/common/MovedBanner.jsx'
import PrivacyShield from './components/common/PrivacyShield.jsx'
import './i18n.js'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AuthProvider>
      <NotificationProvider>
        {/* Whose name is on this. Inside AuthProvider because the answer depends on who is
            asking as well as where they are. */}
        <BrandingProvider>
        {/* Outside App so that the sign-up and sign-in screens are covered too: the first
            thing a new consultant types on a shared screen is their own details. */}
        <PrivacyProvider>
        {/* Namespaces load on demand, so the first screen to ask for one it hasn't got will
            suspend. `Suspense` has been imported here since the beginning and never wired up —
            harmless while every namespace was preloaded at startup, an unhandled suspension the
            moment they aren't. The fallback is deliberately blank: a spinner that flashes for
            the few milliseconds a local JSON fetch takes is worse than nothing. */}
        {/* Above everything, on every screen, whenever this is not the real ProTrack. The
            email markers stop a test notification being taken for a real one; this stops the
            reverse — somebody doing real work in the test copy. */}
        <EnvironmentBanner />
        {/* The old address telling people where the new one is. Above everything for the same
            reason as the banner over it, and nothing at all on every other address. */}
        <MovedBanner />
        {/* Fixed-position, so it belongs beside the banner rather than inside any page. */}
        <PrivacyShield />
        <Suspense fallback={null}>
          <App />
        </Suspense>
        </PrivacyProvider>
        </BrandingProvider>
      </NotificationProvider>
    </AuthProvider>
  </React.StrictMode>,
)

